export class ReverificationPreviousInquiryRequiredError extends Error {
    // This is not client facing, only used internally
    message = 'No last approved inquiry available for re-verification pre-fill';
}
